export default __webpack_public_path__ + "static/jash-patel-layer5-maintainer-01f08a61215210218b29af30595bc5b2.webp";